import clientService from "../../services/clientService";
import Vue from "vue";
import axios from 'axios'
import { distinctById } from "@/utils";

const state = {
    client_loading: true,
    clients_loading: true,
    clients: [],
    collection_clients: [],
    current_client: {},
    opened_client: {},
    next_page: undefined,
    perm_group: {
        '_site': 'Сайт',
        '_album': 'Альбомы',
        '_order': 'Заказы',
        '_purchase': 'Закупка',
        '_client': 'Клиенты',
        '_payments': 'Платежи',
        '_balance_histories': 'История баланса',
        '_purch_histories': 'История закупки',
        '_collection': 'Сборы',
    }
};

var client_request;

const getters = {
    has_perm: state => perm => {
        if (state.client_loading) return false;
        return state.current_client.permissions[perm];
    }
}

const actions = {
    getClientsTotal(store, params) {
        return new Promise((resolve, reject) => {
            clientService.getClientsTotal(params)
                .then(client => {
                    resolve(client)
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить итоги по клиентам.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    getCurrentClient({commit, dispatch, state}) {
        state.client_loading = true;
        return new Promise((resolve) => {
            clientService.getCurrentClient()
                .then(response => {
                    if ('permission_denied' in response) {
                        resolve(response)
                    } else {
                        let client = response;
                        Object.freeze(client['permissions']);
                        commit('setCurrentClient', client);
                        state.client_loading = false;
                        resolve(client)
                    }
                })
                .catch(error => {
                    dispatch('auth/logout', null, {root: true});
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о профиле.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                })
        })
    },
    getOpenedClient({commit}, {client_id, params}) { // Получение открытого клиента

        if (client_request) {
            client_request.cancel();
        }
        const CancelToken = axios.CancelToken;
        client_request = CancelToken.source();

        return new Promise((resolve, reject) => {
            clientService.getClient({client_id, params, token: client_request.token})
                .then(client => {
                    commit('setOpenedClient', client);
                    resolve();
                })
                .catch(error => {
                    if (error.__CANCEL__) {
                        return
                    }
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о клиенте.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    getOpenedClientInfo({commit}, client_id) { // Получение открытого клиента
        return new Promise((resolve, reject) => {
            clientService.getClientInfo(client_id)
                .then(client => {
                    commit('setOpenedClient', client);
                    resolve(client);
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о клиенте.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    editClient(store, client) {
        return new Promise((resolve, reject) => {
            clientService.editClient(client)
                .then(() => {
                    resolve();
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось изменить информацию о клиенте.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    editClientBalance({commit}, data) {
        return new Promise((resolve, reject) => {
            data.request_id = new Date().getTime()
            clientService.editClientBalance(data)
                .then(client => {
                    commit('updateClientBalance', client)
                    resolve();
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось изменить баланс клиенте.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    bulkEditClientPercent(store, data) {
        return new Promise((resolve, reject) => {
            data.request_id = new Date().getTime()
            clientService.bulkEditClientPercent(data)
                .then(() => {
                    resolve();
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось изменить процент клиентов.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    bulkEditClientBalance(store, data) {
        return new Promise((resolve, reject) => {
            data.request_id = new Date().getTime()
            clientService.bulkEditClientBalance(data)
                .then(() => {
                    resolve();
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось изменить балансы клиентов.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    bulkEditClientPermissions(store, data) {
        return new Promise((resolve, reject) => {
            data.request_id = new Date().getTime()
            clientService.bulkEditClientPermissions(data)
                .then(() => {
                    resolve();
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось изменить права клиентов.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    addClient({commit}, client) {
        return new Promise((resolve, reject) => {
            clientService.postClient(client)
                .then(client => {
                    commit('addClient', client)
                    resolve();
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось добавить нового клиента.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    getSpecialInfo({commit}, data) {
        return new Promise((resolve, reject) => {
            clientService.getSpecialInfo(data)
                .then(client => {
                    if (!client) return;
                    commit('addClient', client)
                    resolve();
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить получить специальную информацию о клиенте.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    deleteClient({commit}, client) {
        return new Promise((resolve, reject) => {
            clientService.deleteClient(client.id)
                .then(() => {
                    commit('deleteClient', client.id)
                    resolve();
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось удалить клиента.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    getClients({commit, state}, params) {
        if (state.next_page === null) {
            return
        }
        state.clients_loading = state.next_page === undefined;
        params.cursor = state.next_page;
        return new Promise((resolve, reject) => {
            clientService.getClients(params)
                .then(response => {
                    let clients = distinctById(state.clients.concat(response.results));
                    commit('setClients', {next: response.next, clients});
                    state.clients_loading = false;
                    resolve();
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о клиентах.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    state.clients_loading = false;
                    reject();
                })
        })
    },
    getCollectionClients({commit, state}, params = undefined) {
        return new Promise((resolve, reject) => {
            clientService.getCollectionClients(params)
                .then(response => {
                    commit('setCollectionClients', response);
                    resolve(response);
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить список клиентов для сборов.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    state.client_loading = false;
                    reject();
                })
        })
    },
    sendingVkMessage(store, data) {
        return new Promise((resolve, reject) => {
            clientService.sendingVkMessage(data)
                .then(() => {
                    resolve()
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось разослать сообщение.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    }
};

const mutations = {
    addClient(state, client) {
        const index = state.clients.findIndex(obj => obj.id === client.id);
        if (index !== -1) {
            Vue.set(state.clients, index, client);
        } else {
            state.clients.unshift(client);
        }
    },
    deleteClient(state, client_id) {
        state.clients = state.clients.filter(item => item.id !== client_id);
    },
    updateClientBalance(state, client) {
        let find_client = state.clients.find(obj => obj.id === client.id);
        if (find_client) {
            Vue.set(find_client, 'balance', client.balance);
        }
        find_client = state.collection_clients.find(obj => obj.id === client.id);
        if (find_client && find_client.balance !== undefined) {
            Vue.set(find_client, 'balance', client.balance);
        }
        if (state.opened_client.id === client.id) {
            Vue.set(state.opened_client, 'balance', client.balance);
        }
        if (state.current_client.id === client.id) {
            Vue.set(state.current_client, 'balance', client.balance);
        }
    },
    setOpenedClient(state, client) {
        Vue.set(state, 'opened_client', client);
    },
    setCurrentClient(state, client) {
        state.current_client = client;
    },
    setClients(state, {next, clients}) {
        state.next_page = next;
        state.clients = clients;
    },
    setCollectionClients(state, data) {
        state.collection_clients = data;
    },
    clearData(state) {
        state.next_page = undefined;
        state.clients = [];
        state.collection_clients = [];
        Vue.set(state, 'opened_client', {});
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}